import {
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Tab,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./style.scss";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import backIcon from "../../assets/images/backIcon.svg";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import calendar from "../../assets/images/Calendar.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getOutstandingCommission,
  getPayoutAccounts,
  getPayoutList,
  requestPayout,
} from "../../store/reducers/payoutReducer";
import crossIcon from "../../assets/images/crossIcon.svg";
import { dollarUS } from "../../utilities/formatters";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import DailogBox from "../../components/ReusableComponents/DailogBox";
import competitionAd from "../../assets/images/competitionAd.png";

const RequestPayout = (props) => {
  const { close } = props;
  const [submitOpen, setSubmitOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [tabValue, setTabValue] = useState("Profit Share");
  const [openDBox, setOpenDBox] = useState(false);
  const [closeTradesAgreement, setCloseTradesAgreement] = useState(false);
  const dispatch = useDispatch();
  const { aff_commission } = useSelector((state) => state.payout);
  const [accounts, setAccounts] = useState([]);


  const [data, setData] = useState({
    login_id: "",
    amount: 0,
    reason: "",
  });

  // Pop up states
  // success/ error modal
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  useEffect(() => {
    dispatch(getPayoutAccounts()).then((res) => {
      if (res.accounts) setAccounts(res.accounts);
    });
  }, [dispatch]);

  useEffect(() => {
    if (true) {
      dispatch(getPayoutList());
      dispatch(getOutstandingCommission());
    }
  }, [dispatch]);

  const SubmitHandleClose = () => {
    setSubmitOpen(false);
    close(false);
  };

  // Submit button handler
  const handleSubmit = () => {
    const payload = {
      amount: data.amount,
      reason: data.reason,
    };

    if (tabValue === "Profit Share") {
      payload["login_id"] = data.login_id;
      payload["type"] = "Profit Share";
    } else if (tabValue === "Affiliate Share") {
      payload["type"] = "Affiliate Share";
      if (!data.amount) {
        setShowPopup(true);
        setCombinedPUHead("Oh snap !");
        setCombinedPUBody("Please enter a valid amount!");
        setPopUpType("error");

        return;
      }
    }

    dispatch(requestPayout(payload))
      .then((res) => {
        console.log(res);
        // setMsg("Payout Successful..!");
        // setSubmitOpen(true);
        setCloseTradesAgreement(false);

        setShowPopup(true);
        setCombinedPUHead("Woo hoo !");
        setCombinedPUBody("Payout requested successfully!");
        setPopUpType("success");
        dispatch(getPayoutList());
      })
      .catch((err) => {
        console.log(err);
        setCloseTradesAgreement(false);
        // setMsg("Payout Failed..!");
        // setSubmitOpen(true);
        let msg = "Payout request failed!";
        if (err.response?.data?.message) {
          msg = Object.values(err.response?.data?.message);
        } else if (err.response?.data?.detail) {
          msg = err.response?.data?.detail;
        }

        setShowPopup(true);
        setCombinedPUHead("Oh snap !");
        setCombinedPUBody(msg);
        setPopUpType("error");
      });
  };

  const tabsHandleChange = (event, newValue) => {
    event.preventDefault();
    setTabValue(newValue);
  };

  //Custom Radio buttons
  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 20,
    height: 20,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#04D9FF",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const handlePopUp = () => {
    setOpenDBox(true);
  };

  const handleAgree = (e) => {
    console.log("Agree");
    setOpenDBox(false);
    handleSubmit();
  };

  return (
    <div>
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        onClick={SubmitHandleClose}
      />
      <DailogBox
        open={openDBox}
        setOpen={setOpenDBox}
        title={`Please note: All open trades on account ${data.login_id} will be closed if any and the account will be disabled until the your request is reviewed. Click ok continue.`}
        handleAgree={handleAgree}
      />

      <div
        className="DpboxCon"
        style={{ marginTop: "24px", border: 0, padding: 0 }}
      >
        <Typography className="payout-heading">
          <img
            className="backIcon"
            src={backIcon}
            alt="BackIcon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              close(false);
            }}
          />
          Back
        </Typography>
      </div>
      <Grid2
        xs={12}
        md={12}
        container
        item
        className="gen-info-form"
        spacing={3}
      >
        <Grid2 className="requestPayout-wrapper" item xs={7} md={9} lg={9}>
          <div className="form-grp-in">
            <div
              className="container-box payoutCnt"
              style={{ padding: "20px" }}
            >
              <div className="heading_section">
                <Typography className="payout-heading">
                  Request a New Payout
                </Typography>
                <Typography className="payout-subHeading">
                  Please use this form to request a new payment; we will check
                  and <br></br>contact you for additional information.
                </Typography>
              </div>

              <Box
                className="ContainerTab form_section__"
                sx={{ width: "100%", padding: "0", marginTop: "20px" }}
                p={3}
              >
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      className="buttonContainer"
                      onChange={tabsHandleChange}
                      aria-label="lab API tabs example"
                    >
                      <Tab
                        className="ContainertabName"
                        label="Trading Account"
                        value="Profit Share"
                      />
                      <Tab
                        className="ContainertabName"
                        label="Affiliate"
                        value="Affiliate Share"
                      />
                    </TabList>
                  </Box>
                  <TabPanel
                    style={{ padding: "0px" }}
                    value="Profit Share"
                  >
                    <Grid2 item container gap={'20px'}>
                      {/* <Grid2 item xs={12} md={6}>
                        <div
                          className="container-box"
                          style={{ borderColor: "#04D9FF" }}
                        >
                          <div className="request-container">
                            <div>
                              <FormControl>
                                <RadioGroup defaultValue="Standard">
                                  <FormControlLabel
                                    style={{ margin: 0 }}
                                    value={"Standard"}
                                    control={
                                      <Radio
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        disableRipple
                                      />
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                            <div>
                              <Typography className="payout-heading">
                                Standard
                              </Typography>
                              <Typography className="payout-subHeading">
                                Request to withdraw the full amount payable
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </Grid2> */}
                      {/* <Grid2 item xs={12} md={6}>
                        <div className="container-box">
                          <div className="request-container">
                            <div>
                              <FormControl>
                                <RadioGroup>
                                  <FormControlLabel
                                    style={{ margin: 0 }}
                                    value={"Custom"}
                                    disabled
                                    control={
                                      <Radio
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        disableRipple
                                      />
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                            <div>
                              <Typography className="payout-heading">
                                Custom
                              </Typography>
                              <Typography className="payout-subHeading">
                                Request to withdraw the partial amount payable
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </Grid2> */}
                      <Grid2 item xs={12}>
                        <Typography className="payout-subHeading">
                          Please note*: Accounts in the below dropdown will
                          populate only on their respective withdrawal dates.
                        </Typography>
                      </Grid2>
                      <div className="req_payout_input_wrapper">
                      <Grid2 item xs={12} md={6} className="wrapperDiv">
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="modalcity"
                            className="input-label light_mode_p"
                          >
                            Choose Account Login ID*
                          </Typography>
                          <Select
                            className="form-modal-select selectDiv_"
                            style={{
                              border: "transparent",
                              background: "#010101",
                            }}
                            value={data.login_id}
                            onChange={(e) =>
                              setData((prevState) => ({
                                ...prevState,
                                login_id: e.target.value,
                              }))
                            }
                          >
                            {accounts.length > 0 ? (
                              accounts.map((account) => (
                                <MenuItem
                                  value={account}
                                  className="select_innerDiv"
                                >
                                  {account}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem className="select_innerDiv">
                                No Options
                              </MenuItem>
                            )}
                          </Select>
                        </div>
                      </Grid2>
                      <Grid2 item xs={12} md={6}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label light_mode_p"
                          >
                            Withdraw Amount
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal reqPayoutInput"
                            id="recipient-address"
                            style={{ backgroundColor: "#" }}
                            value={data.amount}
                            onChange={(e) =>
                              setData((prevState) => ({
                                ...prevState,
                                amount: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </Grid2>
                      </div>
                      <Grid2 item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label light_mode_p"
                          >
                            Reason
                          </Typography>
                          <TextField
                            className="request-payout-textarea"
                            sx={{ input: { color: "#fff" } }}
                            style={{
                              border: "none",
                              background:
                                "var(--Inner---inner-box, rgba(159, 159, 159, 0.05)) !important",
                              textAlign: "left",
                              color: "#fff",
                              borderRadius: "10px",
                              overflow: "hidden",
                            }}
                            hintText="Message Field"
                            multiline
                            rows={4}
                            value={data.reason}
                            onChange={(e) =>
                              setData((prevState) => ({
                                ...prevState,
                                reason: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </Grid2>
                      <Grid2 item xs={6} md={4}>
                        <div
                          className="form-grp-in"
                          onClick={handlePopUp}
                          style={{ cursor: "pointer" }}
                        >
                          <Button
                            disabled={accounts && !accounts.length}
                            className="payout-button"
                            style={{ color: "#ffffff", background: "#0D56EB" }}
                            // endIcon={<ArrowRightAltIcon fontSize="medium" />}
                          >
                            Submit
                          </Button>
                        </div>
                      </Grid2>
                    </Grid2>
                  </TabPanel>
                  <TabPanel
                    style={{ padding: "0px", marginTop: "24px" }}
                    value="Affiliate Share"
                  >
                    <Grid2 item container gap={'20px'}>
                    <div className="req_payout_input_wrapper">
                      <Grid2 item xs={12} md={6}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="modalcity"
                            className="input-label"
                          >
                            Amount Withdraw
                          </Typography>
                          <input
                            required
                            type="text"
                            className="input-modal"
                            style={{ border: "none", background: "#222C3A" }}
                            id="recipient-address"
                            value={data.amount}
                            onChange={(e) =>
                              setData((prevState) => ({
                                ...prevState,
                                amount: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </Grid2>
                      <Grid2 item xs={12} md={6}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label"
                          >
                            Available Amount
                          </Typography>
                          <input
                            required
                            disabled
                            type="text"
                            className="input-modal"
                            style={{ border: "none", background: "#222C3A" }}
                            id="recipient-address"
                            value={dollarUS(aff_commission)}
                          />
                        </div>
                      </Grid2>
                      </div>
                      <Grid2 item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label"
                          >
                            Reason
                          </Typography>
                          <TextField
                            style={{
                              border: "none",

                              textAlign: "left",
                            }}
                            className="requestpayout-textfield"
                            hintText="Message Field"
                            multiline
                            rows={4}
                            value={data.reason}
                            onChange={(e) =>
                              setData((prevState) => ({
                                ...prevState,
                                reason: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </Grid2>
                      <Grid2 item xs={6} md={4}>
                        <div className="form-grp-in">
                          <Button
                            disabled={!aff_commission}
                            className="payout-button"
                            style={{
                              color: "#ffffff",
                              background: !aff_commission ? "#d3d3d3" : "rgb(13, 86, 235)",  
                            }}
                            // endIcon={<ArrowRightAltIcon fontSize="medium" />}
                            onClick={handleSubmit}
                          >
                            Submit
                          </Button>
                        </div>
                      </Grid2>
                    </Grid2>
                  </TabPanel>
                </TabContext>
              </Box>
            </div>
          </div>
        </Grid2>

        {/* <Grid2 item xs={6} md={3}>
          <div className="add-container">
            <Typography className="add-text" style={{ marginTop: "50%" }}>
              February<br></br> 2022<br></br>
              Trading<br></br> Competition
            </Typography>
            <Typography
              className="payout-subHeading"
              style={{ marginTop: "30%", color: "rgba(255, 255, 255, 0.6)" }}
            >
              1st prize - Macbook Pro<br></br> (200K Challenge)
            </Typography>
            <Typography
              className="payout-subHeading"
              style={{
                marginTop: "10%",
                color: "rgba(255, 255, 255, 0.6)",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <img
                src={calendar}
                alt=""
                style={{ paddingBottom: "5%", marginRight: "2%" }}
              />
              01 March 2022 To<br></br> 31 March 2022
            </Typography>
            <Button
              className="payout-button"
              style={{
                color: "#04D9FF",
                background: "#ffffff",
                marginTop: "15%",
              }}
            >
              Enter Competition
            </Button>
          </div>
        </Grid2> */}
      </Grid2>
    </div>
  );
};

export default RequestPayout;
